var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 8.84335H7.55624C7.33434 8.84335 7.15683 8.66583 7.15683 8.44394V2.58593C7.15683 2.36404 6.97931 2.18652 6.75742 2.18652C3.25149 2.40842 0.5 5.29304 0.5 8.84335C0.5 12.438 3.60652 15.5446 7.24558 15.5002C10.7515 15.4558 13.5918 12.7043 13.8137 9.24276C13.8137 9.02086 13.6361 8.84335 13.4142 8.84335Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28711 0.5C9.06521 0.5 8.8877 0.677514 8.8877 0.899408V6.75742C8.8877 6.97931 9.06521 7.15683 9.28711 7.15683H15.1007C15.3226 7.15683 15.5001 6.97931 15.5001 6.75742C15.2782 3.38462 12.6155 0.721894 9.28711 0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLinkIcon);
export default __webpack_public_path__ + "static/media/wallet-link-icon.783673e615f8a7e2c573aa5605df4347.svg";
export { ForwardRef as ReactComponent };